import { PageLink, PageTitle } from '_metronic/layout/core';
import { FC } from 'react';
import { useLocation } from 'react-router-dom';
import { PerfilView } from './components/perfilView';


const PerfilPage: FC = () => {
  let location = useLocation();
  const breadCrumbs: Array<PageLink> = [
    {
      title: 'Configuración',
      path: location.pathname,
      isSeparator: false,
      isActive: true,
    },
    {
      title: 'Perfil',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ];

  return (
    <>
      <PageTitle breadcrumbs={breadCrumbs}>Perfil</PageTitle>
      <PerfilView/>
    </>
  );
};

export {PerfilPage}